import FrontLine from './FrontLine';

export default FrontLine;
